import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import SignIn from './views/SignIn.vue';
import store from './store';
import AccountManagement from './views/AccountManagement.vue';
import Profile from './views/AccountManagement/Profile.vue';
import Mailinglists from './views/AccountManagement/Mailinglists.vue';
import Password from './views/AccountManagement/Password.vue';
import MailChange from './views/AccountManagement/MailChange.vue';

Vue.use(Router);

const ifAuthenticated = (to: any, from: any, next: any) => {
  if (store.getters.isLoggedIn) {
    next();
    return;
  }
  store.dispatch('ROUTE_CHANGED', to);
  next('/sign-in');
};

const ifNotAuthenticated = (to: any, from: any, next: any) => {
  if (!store.getters.isLoggedIn) {
    next();
    return;
  }
  next('/');
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/sign-in',
      name: 'SignIn',
      component: SignIn,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/accountmanagement',
      name: 'AccountManagement',
      component: AccountManagement,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: 'profile',
          name: 'AccountManagement-Profile',
          component: Profile,
        },
        {
          path: 'mailinglists',
          name: 'AccountManagement-Mailinglists',
          component: Mailinglists,
        },
        {
          path: 'password',
          name: 'AccountManagement-Password',
          component: Password,
        },
        {
          path: 'mailchange',
          name: 'AccountManagement-MailChange',
          component: MailChange,
        },
      ],
    },
    {
      path: '/misc',
      name: 'Misc',
    },
  ],
});

/* router.beforeEach((to: any, from: any, next: any) => {
  store.dispatch('ROUTE_CHANGED', from);
  next();
}); */

export default router;
